import { ValidationError } from './validation-error';

export class ValidatorResult<T> {
  public errors: ValidationError[];
  public model: T;
  public statusCode?: number;

  constructor(model: T) {
    this.model = model;
    this.errors = new Array<ValidationError>();
  }

  public isValid(): boolean {
    return this.errors.length === 0;
  }
}
